"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _excluded = ["showHistoricalAssets", "hideCoupledAssets", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AssetFilter = function AssetFilter(_ref) {
  var showHistoricalAssets = _ref.showHistoricalAssets,
      hideCoupledAssets = _ref.hideCoupledAssets,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalAssets = (0, _hooks.usePortalAssets)(portalId),
      _usePortalAssets$data = _usePortalAssets.data,
      assets = _usePortalAssets$data === void 0 ? [] : _usePortalAssets$data;

  var _usePortalCoupledAsse = (0, _hooks.usePortalCoupledAssets)(portalId),
      _usePortalCoupledAsse2 = _usePortalCoupledAsse.data,
      coupledAssets = _usePortalCoupledAsse2 === void 0 ? [] : _usePortalCoupledAsse2;

  var _usePortalHistoricalA = (0, _hooks.usePortalHistoricalAssets)(portalId),
      _usePortalHistoricalA2 = _usePortalHistoricalA.data,
      historicalAssets = _usePortalHistoricalA2 === void 0 ? [] : _usePortalHistoricalA2;

  var _usePortalHistoricalC = (0, _hooks.usePortalHistoricalCoupledAssets)(portalId),
      _usePortalHistoricalC2 = _usePortalHistoricalC.data,
      historicalCoupledAssets = _usePortalHistoricalC2 === void 0 ? [] : _usePortalHistoricalC2;

  var onlyHistoricalAssets = (0, _hooks.useOnlyHistoricalAssets)(portalId);
  var source = (0, _react.useMemo)(function () {
    // start with non historical assets only
    var mergedAssets = assets; // include historical and non historical assets

    if (showHistoricalAssets) {
      mergedAssets = historicalAssets;
    }

    if (!hideCoupledAssets) {
      // include historical and non historical coupled assets
      if (showHistoricalAssets) {
        mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(historicalCoupledAssets));
      } else {
        // include non historical coupled assets
        mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(coupledAssets));
      }
    }

    return mergedAssets.reduce(function (result, asset) {
      var nextResult = result;
      nextResult[asset.id] = asset.name;
      return result;
    }, {});
  }, [assets, coupledAssets, historicalAssets, historicalCoupledAssets, hideCoupledAssets, showHistoricalAssets]);

  var optionRenderer = function optionRenderer(_ref2) {
    var isActive = _ref2.isActive,
        onOptionSelect = _ref2.onOptionSelect,
        measureRef = _ref2.measureRef,
        key = _ref2.key,
        style = _ref2.style,
        option = _ref2.option;
    var isSelected = value === option.value;
    var isHistoric = onlyHistoricalAssets.some(function (asset) {
      return asset.id === parseInt(option.value, 10);
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(element) {
        return measureRef(element);
      },
      key: key,
      tabIndex: 0,
      style: style,
      role: "option",
      "aria-selected": isSelected,
      className: (0, _classnames["default"])('bg-white hover:bg-gray-200 break-all text-base cursor-pointer p-1', {
        'text-primary': !isHistoric,
        'text-gray-500': isHistoric,
        'font-bold': isSelected,
        'bg-gray-200': isActive
      }),
      onMouseDown: onOptionSelect
    }, option.label);
  };

  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, _extends({}, props, {
    value: value,
    source: source,
    optionRenderer: optionRenderer,
    debounceTime: 400,
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, null),
    valueType: "Integer"
  }));
};

AssetFilter.propTypes = _objectSpread(_objectSpread({}, _nicbaseForms.Autocomplete.propTypes), {}, {
  showHistoricalAssets: _propTypes["default"].bool,
  hideCoupledAssets: _propTypes["default"].bool
});
AssetFilter.defaultProps = _objectSpread(_objectSpread({}, _nicbaseForms.Autocomplete.defaultProps), {}, {
  showHistoricalAssets: false,
  hideCoupledAssets: false
});
var _default = AssetFilter;
exports["default"] = _default;